import { useState } from 'react';
import { NotesDrawer } from '../../ui';
import { useSessionPeople } from './hooks';

/**
 * Patient "See Notes": a read-only drawer listing the notes the clinician shared with the patient
 * (the notes API only returns visibility "shared" rows to the patient). Returns the header callback
 * and the drawer element to render next to it.
 */
export const usePatientNotes = () => {
  const people = useSessionPeople();
  const [open, setOpen] = useState(false);
  const drawer = (
    <NotesDrawer readOnly open={open} onClose={() => setOpen(false)} appointmentId={people.appointmentId} currentUserId={people.currentUserId} />
  );
  return { onSeeNotes: people.appointmentId ? () => setOpen(true) : undefined, drawer };
};

export default usePatientNotes;
